import { FlexBox, Icon } from '@fable/components'
import { css, cx } from '@fable/theme'
import { useStatsTheme } from '../../theme/ctx'
import { sendHapticOneShot } from 'app/webview/utils'
import { useStats } from '../../lib/ctx/stats'

interface Props {
  className?: string
  disable?: boolean
  onClick?: () => void
}

export const CreateReadingGoalButton = ({
  className = '',
  disable,
  onClick,
}: Props) => {
  const theme = useStatsTheme((s) => s.theme)
  const isWeb = useStats((s) => s.isWeb)

  if (isWeb) return null

  const handleCreate = () => {
    if (disable) return
    onClick?.()
    sendHapticOneShot('light')
  }

  return (
    <FlexBox
      role="button"
      aria-label="add goal"
      data-testid="create-reading-goal-button"
      className={cx(
        css`
          width: 32px;
          height: 32px;
          background-color: ${theme.colors.primary};
          border-radius: 50%;
          overflow: hidden;
          transition: background-color ease-in-out 0.6s;
          will-change: background-color;
        `,
        className
      )}
      onClick={handleCreate}
      centerAll
    >
      <Icon
        className={css`
          width: 16px;
        `}
        type="add"
        fill={theme.colors.section.bg}
      />
    </FlexBox>
  )
}
